module.exports = __webpack_public_path__ + "assets/b73.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b73.png
// module id = 664
// module chunks = 0